$('.docs-section__header').click(function() {
  let $content = $(this).parent().find('.docs-section__content');
  this.classList.toggle('active');
  $content.slideToggle();
});